import hu from './hu';
import en from './en';
import sk from './sk';

export default {
  hu,
  en,
  sk,
}